import React from "react";
import LogoutHeader from '../../components/Headers/LogoutHeader';
import UserRegistration from '../../components/UserRegistration';
import LogoutFooter from '../../components/Footers/LogoutFooter';

const RegistrationPage = () => {
  return (
    <>  
      <LogoutHeader />
      <main>
        <UserRegistration />
      </main>
      <LogoutFooter />
    </>
  );
}

export default RegistrationPage;